import { error, request, success } from 'store/api/actions';
import { baseApi } from 'store/api/apiRequestBuilder';
import { setActiveModal } from 'store/modals/reducer';
import { call, put, takeLatest } from 'typed-redux-saga';
import { Modals } from 'types';
import { logger } from 'utils';

import { sendDeliveryInfo } from '../actions';
import actionTypes from '../actionTypes';

export function* sendDeliveryInfoSaga({
  type,
  payload: { id, data, setSubmitting, resetForm },
}: ReturnType<typeof sendDeliveryInfo>) {
  yield* put(request(type));
  try {
    yield* call(baseApi.sendDeliveryInfo, +id, { data });

    yield* put(success(type));
  } catch (err) {
    yield* put(error(type, err));
    logger('sendDeliveryInfo', err);
  } finally {
    yield* put(setActiveModal({ activeModal: Modals.Custody, open: true }));
    setSubmitting(false);
    resetForm();
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.SEND_DELIVERY_INFO, sendDeliveryInfoSaga);
}
